import Div from "@jumbo/shared/Div/Div";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Button,
  InputAdornment,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getAllSales } from "app/redux/actions/salesAction";
import { CuttingListInfoModal } from "app/pages/Order/Cutter/List/cuttingListInfoModal";
import { displayDateFun } from "app/utils/constants/functions";
import FullScreenLoader from "app/components/ListingPageLoader";

export default function NormalOrderSalesTable({ searchTerm, page, setPage, inputs }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [isItemOpen, setIsItemOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const { allSales, TotalPage, loading } = useSelector((state) => state.salesReducer);
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  const sortedData = allSales?.sort((a, b) => {
    let aValue;
    let bValue;
    // console.log(orderBy);
    if (orderBy == "order_item_name") {
      aValue = a.order_item_name.toLowerCase();
      bValue = b.order_item_name.toLowerCase();
    } else if (orderBy == "order_sub_item_name") {
      aValue = a.order_sub_item_name.toLowerCase();
      bValue = b.order_sub_item_name.toLowerCase();
    } else {
      aValue = a[orderBy];
      bValue = b[orderBy];
    }
    if (order === "desc") {
      return aValue < bValue ? -1 : 1;
    } else {
      return bValue < aValue ? -1 : 1;
    }
  });

  const handleChangePage = (event, page) => {
    setPage(page);
    dispatch(getAllSales(searchTerm, inputs, page));
  };

  useEffect(() => {
    (async () => {
      dispatch(getAllSales("", "", 1));
    })();
  }, []);

  return (
    <>
      {loading && <FullScreenLoader />}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "140px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Port No & Name
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  width: "110px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "order_no"}
                  direction={order}
                  onClick={() => handleSort("order_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Order No.
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  width: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "order_item_name"}
                  direction={order}
                  onClick={() => handleSort("order_item_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  width: "130px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "order_sub_item_name"}
                  direction={order}
                  onClick={() => handleSort("order_sub_item_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Sub Item Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "order_item_job_work_id"}
                  direction={order}
                  onClick={() => handleSort("order_item_job_work_id")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Job Work ID
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "factory_name"}
                  direction={order}
                  onClick={() => handleSort("factory_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Factory Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "productions_invoice_no"}
                  direction={order}
                  onClick={() => handleSort("productions_invoice_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Factory Bill No.
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "productions_invoice_date"}
                  direction={order}
                  onClick={() => handleSort("productions_invoice_date")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Invoice Date
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  px: 1,
                  textAlign: "center",
                  width: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Order Details
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Raw Manual Issue (QTY)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Raw Manual Issue (Rate)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Price (USD)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price_in_INR"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price_in_INR")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Price (INR)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_addOns_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_addOns_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Add Ons Price
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_suit_cover_cost"}
                  direction={order}
                  onClick={() => handleSort("cost_price_suit_cover_cost")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Suit Cover Price
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_freight"}
                  direction={order}
                  onClick={() => handleSort("selling_price_freight")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Freight
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_other_charges"}
                  direction={order}
                  onClick={() => handleSort("selling_price_other_charges")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Other Charges
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "100px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                <TableSortLabel
                  active={orderBy === "total_selling_price"}
                  direction={order}
                  onClick={() => handleSort("total_selling_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Total (SP)
                </TableSortLabel>
              </TableCell>
              {permissions?.sales_edit == true && (
                <TableCell
                  sx={{
                    textAlign: "left",
                    minWidth: "95px",
                    verticalAlign: "middle",
                    color: "white",
                    px: 1,
                    position: "sticky",
                    right: 0,
                    height: "58px",
                    zIndex: 1,
                    bgcolor: "#202020",
                  }}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData?.map((row, i) => (
              <TableRow key={i}>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.order_port_no_and_name}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.order_no}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.order_item_name}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.order_sub_item_name}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.order_item_job_work_id}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.factory_name}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{row?.productions_invoice_no}</TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>{displayDateFun(row?.productions_invoice_date)}</TableCell>
                <TableCell sx={{ textAlign: "center", px: 1 }}>
                  <InfoIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsItemOpen(true);
                      setSelectedRowData(row);
                    }}
                  />
                </TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>
                  {row?.raw_manually_issue_quantity ? row?.raw_manually_issue_quantity : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left", px: 1 }}>
                  {row?.raw_cost_details && row?.raw_manually_issue_quantity
                    ? row?.raw_cost_details * row?.raw_manually_issue_quantity
                    : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.selling_price_item_price ? Math.round(row?.selling_price_item_price) : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.selling_price_item_price_in_INR ? Math.round(row?.selling_price_item_price_in_INR) : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.selling_price_addOns_price ? row?.selling_price_addOns_price : "-"}</TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.cost_price_suit_cover_cost ? row?.cost_price_suit_cover_cost : "-"}</TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.selling_price_freight ? row?.selling_price_freight : "-"}</TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.selling_price_other_charges ? row?.selling_price_other_charges : "-"}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>{row?.total_selling_price ? Math.round(row?.total_selling_price) : "-"}</TableCell>
                {permissions?.sales_edit == true && (
                  <TableCell
                    sx={{
                      textAlign: "left",
                      px: 1,
                      position: "sticky",
                      right: 0,
                      zIndex: 1,
                      bgcolor: "white",
                    }}
                  >
                    <Typography
                      size="small"
                      fontWeight={600}
                      sx={{
                        cursor: "pointer",
                        ":hover": { color: "purple" },
                      }}
                      onClick={() => {
                        navigate("/dashboard/sales/edit", { state: row });
                      }}
                    >
                      Edit
                    </Typography>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
          <CuttingListInfoModal
            type="normalOrder"
            open={isItemOpen}
            onClose={() => {
              setIsItemOpen(false);
            }}
            rowData={selectedRowData}
          />
        </Table>
        <Pagination
          count={TotalPage || 1} // Replace with the actual total number of pages
          page={page}
          onChange={handleChangePage}
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
            p: 2,
          }}
        />
      </TableContainer>
    </>
  );
}
